var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-form",
        {
          ref: "pram",
          attrs: { inline: true, "label-width": "120px" },
          model: {
            value: _vm.pram,
            callback: function ($$v) {
              _vm.pram = $$v
            },
            expression: "pram",
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card-item" },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: { label: _vm.$t("qybl") },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.pram.all_win_rate,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "all_win_rate", $$v)
                      },
                      expression: "pram.all_win_rate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "0" },
                  attrs: { label: _vm.$t("qkbl") },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.pram.all_low_rate,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "all_low_rate", $$v)
                      },
                      expression: "pram.all_low_rate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-card", { staticClass: "box-card-item" }, [
            _c(
              "div",
              {
                staticClass: "box-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("wysjd")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("startTime") },
                  },
                  [
                    _c("el-time-picker", {
                      attrs: { format: "HH:mm", placeholder: _vm.$t("xzsj") },
                      model: {
                        value: _vm.pram.ying_start_time,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "ying_start_time", $$v)
                        },
                        expression: "pram.ying_start_time",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("endTime") },
                  },
                  [
                    _c("el-time-picker", {
                      attrs: { format: "HH:mm", placeholder: _vm.$t("xzsj") },
                      model: {
                        value: _vm.pram.ying_end_time,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "ying_end_time", $$v)
                        },
                        expression: "pram.ying_end_time",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["productCenter:productControl:time1"],
                        expression: "['productCenter:productControl:time1']",
                      },
                    ],
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit("wenyin")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("qrtj")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-item-area" },
              _vm._l(_vm.pram.wenyin, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticStyle: { "margin-right": "5px" },
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.deleteIndex(index, "wenyin")
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(tag) + "\n          ")]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-card", { staticClass: "box-card-item" }, [
            _c(
              "div",
              {
                staticClass: "box-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("wssjd")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("startTime") },
                  },
                  [
                    _c("el-time-picker", {
                      attrs: { format: "HH:mm", placeholder: _vm.$t("xzsj") },
                      model: {
                        value: _vm.pram.shu_start_time,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "shu_start_time", $$v)
                        },
                        expression: "pram.shu_start_time",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("endTime") },
                  },
                  [
                    _c("el-time-picker", {
                      attrs: { format: "HH:mm", placeholder: _vm.$t("xzsj") },
                      model: {
                        value: _vm.pram.shu_end_time,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "shu_end_time", $$v)
                        },
                        expression: "pram.shu_end_time",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["productCenter:productControl:time2"],
                        expression: "['productCenter:productControl:time2']",
                      },
                    ],
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit("wenshu")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("qrtj")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-item-area" },
              _vm._l(_vm.pram.wenshu, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticStyle: { "margin-right": "5px" },
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.deleteIndex(index, "wenshu")
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(tag) + "\n          ")]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-card", { staticClass: "box-card-item" }, [
            _c(
              "div",
              {
                staticClass: "box-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("zdkhyl")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("tjyh") },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "" },
                        model: {
                          value: _vm.pram.zdylr,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "zdylr", $$v)
                          },
                          expression: "pram.zdylr",
                        },
                      },
                      _vm._l(_vm.userList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: item.uid + "(" + item.account + ")",
                            value: item.uid,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["productCenter:productControl:time3"],
                        expression: "['productCenter:productControl:time3']",
                      },
                    ],
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit("to_win")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("qrtj")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-item-area" },
              _vm._l(_vm.pram.to_win, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticStyle: { "margin-right": "5px" },
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.deleteIndex(index, "to_win")
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(tag) + "\n          ")]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-card", { staticClass: "box-card-item" }, [
            _c(
              "div",
              {
                staticClass: "box-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("zdkhks")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("tjyh") },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { filterable: "" },
                        model: {
                          value: _vm.pram.zdksr,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "zdksr", $$v)
                          },
                          expression: "pram.zdksr",
                        },
                      },
                      _vm._l(_vm.userList, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            "collapse-tags": "",
                            label: item.uid + "(" + item.account + ")",
                            value: item.uid,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["productCenter:productControl:time4"],
                        expression: "['productCenter:productControl:time4']",
                      },
                    ],
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit("to_loss")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("qrtj")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-item-area" },
              _vm._l(_vm.pram.to_loss, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticStyle: { "margin-right": "5px" },
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.deleteIndex(index, "to_loss")
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(tag) + "\n          ")]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _c("el-card", { staticClass: "box-card-item" }, [
            _c(
              "div",
              {
                staticClass: "box-header",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_vm._v("\n        " + _vm._s(_vm.$t("fkgl")) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-content" },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("jeqj") },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-start" },
                      [
                        _c("el-input", {
                          staticStyle: {
                            width: "100px",
                            "margin-right": "5px",
                          },
                          model: {
                            value: _vm.pram.fkzxje,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "fkzxje", $$v)
                            },
                            expression: "pram.fkzxje",
                          },
                        }),
                        _vm._v(" \n            -\n            "),
                        _c("el-input", {
                          staticStyle: { width: "100px", "margin-left": "5px" },
                          model: {
                            value: _vm.pram.fkzdje,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "fkzdje", $$v)
                            },
                            expression: "pram.fkzdje",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("ylgl") },
                  },
                  [
                    _c("el-input", {
                      staticStyle: { width: "100px" },
                      model: {
                        value: _vm.pram.ylgl,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "ylgl", $$v)
                        },
                        expression: "pram.ylgl",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["productCenter:productControl:time5"],
                        expression: "['productCenter:productControl:time5']",
                      },
                    ],
                    staticStyle: { "margin-bottom": "0" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit("chance")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("qrtj")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "box-item-area" },
              _vm._l(_vm.pram.chance, function (tag, index) {
                return _c(
                  "el-tag",
                  {
                    key: index,
                    staticStyle: { "margin-right": "5px" },
                    attrs: { closable: "" },
                    on: {
                      close: function ($event) {
                        return _vm.deleteIndex(index, "chance")
                      },
                    },
                  },
                  [_vm._v("\n            " + _vm._s(tag) + "\n          ")]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "box-content",
                staticStyle: { "margin-top": "20px" },
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { label: _vm.$t("zxfkje") },
                  },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.pram.min_risk_money,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "min_risk_money", $$v)
                        },
                        expression: "pram.min_risk_money",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { staticStyle: { "margin-bottom": "0" } }, [
                  _c("span", { staticClass: "notes" }, [
                    _vm._v(
                      "\n            \n            " +
                        _vm._s(_vm.$t("zyxddcje")) +
                        "\n          "
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dialog-footer flex-end" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }